/* Jalecos Mania — favoritos (wishlist local, fonte única de verdade).
   Guarda HANDLES de produto no localStorage (handles permitem renderizar os
   cards reais via Section Rendering na página de favoritos). Expõe
   window.JMWishlist e dispara 'jm:wishlist:change' a cada mudança; também
   mantém o contador do header ([data-favorites-count]) sempre em dia. */
(function () {
  var KEY = 'jm-wishlist';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      // migração: versões antigas gravavam IDs numéricos — sem como resolver
      // para handle no client, então são descartados silenciosamente
      return list.filter(function (h) { return typeof h === 'string' && h && !/^\d+$/.test(h); });
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    syncCounts();
    document.dispatchEvent(new CustomEvent('jm:wishlist:change', { detail: { handles: list } }));
  }

  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  window.JMWishlist = {
    read: read,
    has: function (handle) { return read().indexOf(handle) !== -1; },
    toggle: function (handle) {
      if (!handle) return false;
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) list.unshift(handle);
      else list.splice(i, 1);
      write(list);
      return i === -1; // true = acabou de ser adicionado
    },
    remove: function (handle) {
      var list = read().filter(function (h) { return h !== handle; });
      write(list);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCounts);
  } else {
    syncCounts();
  }

  // outra aba mudou os favoritos → atualiza contador e avisa a página
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      syncCounts();
      document.dispatchEvent(new CustomEvent('jm:wishlist:change', { detail: { handles: read() } }));
    }
  });
})();
